<template lang="pug">
k-page.admin
  transition( name='fade-fast' mode='out-in' appear )
    d-loading( v-if='loading')
    component( v-else :is='`admin-${component}`' :post='post' )
</template>

<script lang="js">
import { mapState } from 'vuex'
import adminPages from './admin'
import DLoading from '@/displays/d-loading'
import KPage from '@/blocks/k-page'
import { toAdminPath } from '@/lib/route-events'

export default {
  name: 'AdminPage',
  mixins: [],
  components: {
    ...adminPages,
    DLoading,
    KPage
  },
  props: {
    path: {
      type: String,
      default: 'dashboard'
    },
    section: {
      type: String,
      default: ''
    },
    item: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
    }
  },
  beforeRouteUpdate: toAdminPath,
  created() {},
  mounted() {},
  methods: {},
  computed: {
    ...mapState({
      loading: state => state.loading[ 'admin-page' ],
      post: state => state.post,
    }),
    component() {
      return ( this.post && this.post.view ) || 'dashboard'
    }
  }
}
</script>

<style lang="scss">
.page.admin {
  .bottom-spacer {
    display: none;
    height: 0;
  }
  main {
    padding: 0 var(--s-lg) var(--s-lg);
    h1.title {
      font-size: var(--s-xl);
      margin-top: 0;
      margin-bottom: var(--s-base);
      text-shadow: 0 0 8px rgba(0,0,0,0.2);
    }
  }
  .d-loading {
    height: 100%;
    --c-border: white;
  }
}
</style>
